// extracted by mini-css-extract-plugin
module.exports = {"create_comment_container":"CreateComment_create_comment_container__x1RMI","createComment_textarea":"CreateComment_createComment_textarea__2Bs_h"};